import Page from 'components/Page';
import React, { Component } from 'react';
import { Map, InfoWindow, Marker, Polygon,Polyline,GoogleApiWrapper } from 'google-maps-react';
import axios from 'axios';
import Modal from "react-responsive-modal";
import {
  Card,
  CardTitle,
  CardBody,
  CardImg,
  CardImgOverlay,
  CardText,
  CardLink,
  ListGroup,
  ListGroupItem,
  Row,
  Col,
  Button,
} from 'reactstrap';

const tableTypes = ['', 'bordered', 'striped', 'hover'];


const mapStyles = {
  width: '90%',
  height: '70%'
};

const styles = {
  fontFamily: "sans-serif",
  textAlign: "center",
  width:"1000px"
};

export class Analisa extends Component {

  constructor(props) {
    super(props);

    this.state = {
      data:[],
      pending:[],
      diterima:[],
      kringan:[],
      ksedang:[],
      kberat:[],
      dataLotur:0,
      datakab:[],
      totalkab:[],
      kerugiankab:[],
    showingInfoWindow: false,
    activeMarker: {},
    selectedPlace: {},
    selectedPoly: {},
    wlotim:'',
    wlobar:'',
    wloteng:'',
    wlotur:'',
    wmataram:'',
    };
  }

  onOpenModal = (props, marker, e) => {
    this.setState({ open: true,
      selectedPoly: props, });
  };

  onCloseModal = () => {
    this.setState({ open: false });
  };
  
  onMarkerClick = (props, marker, e) =>
  this.setState({
    selectedPlace: props,
    activeMarker: marker,
    showingInfoWindow: true,
    open: false,
  });


  onMapClicked = (props) => {
    if (this.state.showingInfoWindow) {
      this.setState({
        showingInfoWindow: false,
        activeMarker: null
      })
    }
  };

  componentWillMount(){

    axios.get('https://backendmha.herokuapp.com/api/countkerusakanbykab')
    .then(res => {
      let wlotim;

       this.setState({ dataLotur: res.data[2].total});

       if (res.data[0].total > 35){
        wlotim = '#ff3333';
       }else{
        wlotim = '#ffff00';
       }

       this.setState({ wlotim });

      for (var i = 0; i < res.data.length; i++) {    
        this.state.totalkab.push(res.data[i].total)
      }

    }) 

  }

  componentDidMount() {

    axios.get('https://backendmha.herokuapp.com/api/countstatusperkab')
    .then(res => {

      for (var i = 0; i < res.data.pending.length; i++) {    
        this.state.pending.push(res.data.pending[i].total)
        this.state.diterima.push(res.data.diterima[i].total)
      }

    }) 


    axios.get('https://backendmha.herokuapp.com/api/tingkatdikab')
    .then(res => {
      console.log("tingkat di kab "+ res.data.ringan[1].total)
      for (var i = 0; i < res.data.ringan.length; i++) {    
        this.state.kringan.push(res.data.ringan[i].total)
        this.state.ksedang.push(res.data.sedang[i].total)
        this.state.kberat.push(res.data.berat[i].total)
      }
      console.log("tingkat di kab2 "+ this.state.kringan)

    }) 

    axios.get('https://backendmha.herokuapp.com/api/counthargakab')
    .then(res => {
      console.log("DATA  KERUSAKAN "+ res.data[2].total)
      for (var i = 0; i < res.data.length; i++) {    
        this.state.kerugiankab.push(res.data[i].total)
      }

      console.log("DATA  KERUSAKAN KU"+  this.state.kerugiankab)

    }) 

    axios.get('https://backendmha.herokuapp.com/api/asassment')
    .then(res => {
      const data = res.data;
      this.setState({ data });
      console.log("DATA PETA "+res.data[1].long)
    }) 

  }

  render() {

    const { open } = this.state;

    const lotur = [
      {lat:-8.254508195816811, lng: 116.49526347189556},
{lat:-8.214413780503023, lng: 116.36411417990337},
{lat:-8.264021528135677, lng: 116.24807108908306},
{lat:-8.317688269330436, lng: 116.19618129359515},
{lat:-8.353872837509213, lng: 116.17703047360988},
{lat:-8.366780462712214, lng: 116.13694661169734},
{lat:-8.378268749389212, lng: 116.11521767110116},
{lat:-8.402044131136869, lng: 116.09667824239023},
{lat:-8.408157565370376, lng: 116.08019875020273},
{lat:-8.414950156989931, lng: 116.06371925801523},
{lat:-8.426497289298013, lng: 116.05341957539804},
{lat:-8.437364863624556, lng: 116.04929970235116},
{lat:-8.452307279009194, lng: 116.0403733107496},
{lat:-8.480832099583818, lng: 116.04311989278085},
{lat:-8.476757254689131, lng: 116.0733322951246},
{lat:-8.471324060979885, lng: 116.0953049513746},
{lat:-8.474040667429595, lng: 116.16602943867929},
{lat:-8.473361517616002, lng: 116.1941819044996},
{lat:-8.474040667429595, lng: 116.21203468770273},
{lat:-8.46113661598311, lng: 116.21890114278085},
{lat:-8.446194542648401, lng: 116.29580543965585},
{lat:-8.433968779474045, lng: 116.32807777852304},
{lat:-8.417667160287575, lng: 116.3589768263746},
{lat:-8.425507934388358, lng: 116.39533996582031},
{lat:-8.425507934388358, lng: 116.39533996582031},
{lat:-8.425507934388358, lng: 116.39533996582031},
{lat:-8.425507934388358, lng: 116.39533996582031},
{lat:-8.412233134632052, lng: 116.3809494826246},
{lat:-8.39932701832451, lng: 116.38712929219491},
{lat:-8.382344632429653, lng: 116.42008827656991},
{lat:-8.367236551185025, lng: 116.4380234204832},
{lat:-8.344138420902027, lng: 116.45793614020977},
{lat:-8.312206404305774, lng: 116.47441563239727},
{lat:-8.283669210400088, lng: 116.48952183356914},
{lat:-8.271438350505974, lng: 116.49501499763164},
{lat:-8.256489006332234, lng: 116.49707493415508},
{lat:-8.2524118141899, lng: 116.49638828864727},
    ];

    const mataram = [
      {lat:-8.62412487836284, lng: 116.07652045582506},
{lat:-8.623106554239671, lng: 116.0844168791649},
{lat:-8.62208822737182, lng: 116.09025336598131},
{lat:-8.620051565403436, lng: 116.09746314381334},
{lat:-8.618354338712768, lng: 116.10518790577623},
{lat:-8.61699655187377, lng: 116.11239768360826},
{lat:-8.616657104402126, lng: 116.12338401173326},
{lat:-8.614959862472961, lng: 116.12681723927233},
{lat:-8.616657104402126, lng: 116.14638663624498},
{lat:-8.599005416215817, lng: 116.14398337696764},
{lat:-8.590858205736174, lng: 116.14261008595201},
{lat:-8.582710820235503, lng: 116.1419234404442},
{lat:-8.571168391488103, lng: 116.13849021290514},
{lat:-8.569470945924765, lng: 116.13711692188951},
{lat:-8.569470945924765, lng: 116.12407065724108},
{lat:-8.567773492783386, lng: 116.11514426563951},
{lat:-8.56784529496724, lng: 116.10133874296093},
{lat:-8.56716631171735, lng: 116.09172570585156},
{lat:-8.569542747788109, lng: 116.07593285917187},
{lat:-8.572258656538416, lng: 116.07146966337109},
{lat:-8.578369380264537, lng: 116.07284295438672},
{lat:-8.58481948198596, lng: 116.07284295438672},
{lat:-8.59296682220445, lng: 116.07352959989453},
{lat:-8.601113987360263, lng: 116.07387292264843},
{lat:-8.606884790005376, lng: 116.07558953641797},
{lat:-8.620802246100382, lng: 116.07490289091015},
{lat:-8.624536110572386, lng: 116.07627618192578},
    ];

    
    const loteng = [
      {lat:-8.861414454603654, lng: 116.14840956452258},
      {lat:-8.83902493668304, lng: 116.16832228424914},
      {lat:-8.828168922860261, lng: 116.17244215729602},
      {lat:-8.81324138229115, lng: 116.17587538483508},
      {lat:-8.7905620320392, lng: 116.18802378993087},
      {lat:-8.769525459263756, lng: 116.20175670008712},
      {lat:-8.75120231202479, lng: 116.21342967371993},
      {lat:-8.725412651098555, lng: 116.21960948329024},
      {lat:-8.709123525873597, lng: 116.22029612879805},
      {lat:-8.687403588912426, lng: 116.22029612879805},
      {lat:-8.674437001591073, lng: 116.23212525465146},
      {lat:-8.627597496147638, lng: 116.2341851911749},
      {lat:-8.615377537865205, lng: 116.23143860914365},
      {lat:-8.611983034905471, lng: 116.2451715192999},
      {lat:-8.604515021198132, lng: 116.29941651441709},
      {lat:-8.59501006346891, lng: 116.30696961500303},
      {lat:-8.580991923801943, lng: 116.30810044828218},
      {lat:-8.555869604870196, lng: 116.3094737392978},
      {lat:-8.540252192607708, lng: 116.31771348539155},
      {lat:-8.531424676733183, lng: 116.32663987699311},
      {lat:-8.519880694306869, lng: 116.33831285062593},
      {lat:-8.506299092443713, lng: 116.35135911527436},
      {lat:-8.496791684586917, lng: 116.35685227933686},
      {lat:-8.483888396985918, lng: 116.36303208890718},
      {lat:-8.456042984517923, lng: 116.37401841703218},
      {lat:-8.443138330256458, lng: 116.37607835355561},
      {lat:-8.441100713811805, lng: 116.40132277360635},
      {lat:-8.439063086613405, lng: 116.43634169450479},
      {lat:-8.458710772358389, lng: 116.46380751481729},
      {lat:-8.507142946502936, lng: 116.45275470045385},
      {lat:-8.537021768002209, lng: 116.43627520826635},
      {lat:-8.549244248619484, lng: 116.42666217115698},
      {lat:-8.585909336615996, lng: 116.40331622389135},
      {lat:-8.61035076163305, lng: 116.3895833137351},
      {lat:-8.6530560757684, lng: 116.39372883002557},
      {lat:-8.665274813011514, lng: 116.39372883002557},
      {lat:-8.708715992299716, lng: 116.40883503119744},
      {lat:-8.739936225415635, lng: 116.41020832221307},
      {lat:-8.772511071725967, lng: 116.40471515815057},
      {lat:-8.78608308152471, lng: 116.40883503119744},
      {lat:-8.813225609759929, lng: 116.39372883002557},
      {lat:-8.840366144557898, lng: 116.39510212104119},
      {lat:-8.852578733274566, lng: 116.39922199408807},
      {lat:-8.862077133127679, lng: 116.38411579291619},
      {lat:-8.882430020066982, lng: 116.38686237494744},
      {lat:-8.895997983830856, lng: 116.39647541205682},
      {lat:-8.907619430128399, lng: 116.39401268757149},
      {lat:-8.923221470609864, lng: 116.39126610554024},
      {lat:-8.946620605215038, lng: 116.39538597858711},
      {lat:-8.947298896123604, lng: 116.38989281452461},
      {lat:-8.948655474147923, lng: 116.37478661335274},
      {lat:-8.94119423244517, lng: 116.37341332233711},
      {lat:-8.930341244379704, lng: 116.36998009479805},
      {lat:-8.922879627666832, lng: 116.37547325886055},
      {lat:-8.89913710551806, lng: 116.37959313190743},
      {lat:-8.899815484692756, lng: 116.3672335127668},
      {lat:-8.895066804062468, lng: 116.34045433796211},
      {lat:-8.914739508162175, lng: 116.34457421100899},
      {lat:-8.926949619340675, lng: 116.34663414753243},
      {lat:-8.918809590600663, lng: 116.33358788288399},
      {lat:-8.912704449934571, lng: 116.33015465534493},
      {lat:-8.906599207248371, lng: 116.32466149128243},
      {lat:-8.90524247280366, lng: 116.31710839069649},
      {lat:-8.904564103693524, lng: 116.29788231647774},
      {lat:-8.89913710551806, lng: 116.29238915241524},
      {lat:-8.890996457351436, lng: 116.2793428877668},
      {lat:-8.904564103693524, lng: 116.2683565596418},
      {lat:-8.912704449934571, lng: 116.27590966022774},
      {lat:-8.905920840655302, lng: 116.26217675007149},
      {lat:-8.903885733324996, lng: 116.25119042194649},
      {lat:-8.9011722392688, lng: 116.2463839033918},
      {lat:-8.903207361698165, lng: 116.2408907393293},
      {lat:-8.912704449934571, lng: 116.24020409382149},
      {lat:-8.912704449934571, lng: 116.23745751179024},
      {lat:-8.90727757258277, lng: 116.2353975752668},
      {lat:-8.898458725085723, lng: 116.23265099323555},
      {lat:-8.89710196044845, lng: 116.22853112018868},
      {lat:-8.89778034339582, lng: 116.22029137409493},
      {lat:-8.906599207248371, lng: 116.22166466511055},
      {lat:-8.902528988813131, lng: 116.21548485554024},
      {lat:-8.9011722392688, lng: 116.19625878132149},
      {lat:-8.912704449934571, lng: 116.19831871784493},
      {lat:-8.910669380371393, lng: 116.18870568073555},
      {lat:-8.910669380371393, lng: 116.17977928913399},
      {lat:-8.909312661032981, lng: 116.17359947956368},
      {lat:-8.9011722392688, lng: 116.16879296100899},
      {lat:-8.89642357624371, lng: 116.1639864424543},
      {lat:-8.892353244615594, lng: 116.16192650593086},
      {lat:-8.88760446720324, lng: 116.1639864424543},
      {lat:-8.88285562824321, lng: 116.16055321491524},
      {lat:-8.878106727767333, lng: 116.16329979694649},
      {lat:-8.867930305464661, lng: 116.16329979694649},
      {lat:-8.863181211860441, lng: 116.15094017780586},
      {lat:-8.86182431669753, lng: 116.14682030475899},
    ];

    const lotim = [
      {lat:-8.25770510244819, lng: 116.51303660427334},
      {lat:-8.2712953968545, lng: 116.49793040310146},
      {lat:-8.303910190114955, lng: 116.48694407497646},
      {lat:-8.32429306065022, lng: 116.48007761989834},
      {lat:-8.344674870269413, lng: 116.47664439235928},
      {lat:-8.385435296664891, lng: 116.4340723708749},
      {lat:-8.40721962087475, lng: 116.42583262478115},
      {lat:-8.449331868638385, lng: 116.42995249782803},
      {lat:-8.46155714495894, lng: 116.42995249782803},
      {lat:-8.51045436434963, lng: 116.41896616970303},
      {lat:-8.525393937657372, lng: 116.41484629665615},
      {lat:-8.581072649602305, lng: 116.3846338943124},
      {lat:-8.640816330924798, lng: 116.3846338943124},
      {lat:-8.658466064571506, lng: 116.38188731228115},
      {lat:-8.664642277170001, lng: 116.39775753285562},
      {lat:-8.674145480953847, lng: 116.4128637340275},
      {lat:-8.697223688530146, lng: 116.42796993519937},
      {lat:-8.750162433151543, lng: 116.42659664418375},
      {lat:-8.766449765288549, lng: 116.42522335316812},
      {lat:-8.785450750339857, lng: 116.41835689809},
      {lat:-8.81358818758858, lng: 116.39574403500455},
      {lat:-8.848870458530486, lng: 116.3875042889108},
      {lat:-8.852941272405625, lng: 116.40261049008268},
      {lat:-8.833943755901696, lng: 116.41771669125455},
      {lat:-8.824444630394565, lng: 116.45067567562955},
      {lat:-8.825801663299307, lng: 116.47951478695768},
      {lat:-8.84208566868639, lng: 116.47127504086393},
      {lat:-8.889576567715942, lng: 116.45754213070768},
      {lat:-8.905857746117059, lng: 116.4479290935983},
      {lat:-8.916711462387516, lng: 116.44106263852018},
      {lat:-8.918068154248122, lng: 116.48363466000455},
      {lat:-8.886862967592483, lng: 116.5028607342233},
      {lat:-8.866510326530094, lng: 116.51247377133268},
      {lat:-8.89500370765238, lng: 116.5303265545358},
      {lat:-8.886862967592483, lng: 116.5632855389108},
      {lat:-8.866510326530094, lng: 116.57015199398893},
      {lat:-8.844799599627395, lng: 116.5138470623483},
      {lat:-8.861082764991833, lng: 116.4973675701608},
      {lat:-8.838014734781279, lng: 116.49462098812955},
      {lat:-8.81630232820769, lng: 116.49324769711393},
      {lat:-8.793231497922314, lng: 116.50423402523893},
      {lat:-8.775588128433327, lng: 116.52208680844205},
      {lat:-8.756586638719197, lng: 116.53856630062955},
      {lat:-8.741656215719924, lng: 116.54955262875455},
      {lat:-8.721295584030496, lng: 116.55367250180143},
      {lat:-8.657491761912025, lng: 116.5852581951608},
      {lat:-8.639841982610376, lng: 116.60585756039518},
      {lat:-8.596392855646224, lng: 116.6237103435983},
      {lat:-8.570592577984112, lng: 116.65392274594205},
      {lat:-8.548864670005333, lng: 116.65254945492643},
      {lat:-8.524419293057056, lng: 116.6566693279733},
      {lat:-8.508121506283956, lng: 116.66353578305143},
      {lat:-8.48503178811934, lng: 116.65941591000455},
      {lat:-8.466015683562803, lng: 116.68001527523893},
      {lat:-8.440647781474343, lng: 116.69554570250602},
      {lat:-8.421629487474483, lng: 116.70241215758415},
      {lat:-8.394458875186013, lng: 116.7106519036779},
      {lat:-8.370003698160607, lng: 116.71477177672477},
      {lat:-8.336035627521262, lng: 116.68730595641227},
      {lat:-8.3197299046898, lng: 116.66807988219352},
      {lat:-8.291193257571804, lng: 116.6447339349279},
      {lat:-8.289834317892355, lng: 116.62550786070915},
      {lat:-8.276244662929694, lng: 116.57606938414665},
      {lat:-8.264013572555552, lng: 116.5458569818029},
      {lat:-8.258577410624982, lng: 116.52663090758415},
      {lat:-8.255859301582696, lng: 116.5183911614904},
      {lat:-8.257218358442966, lng: 116.51427128844352},
    ];

    const lobar = [
      {lat:-8.496881348372058, lng: 116.04735287072072},
      {lat:-8.492806673791739, lng: 116.08031185509572},
      {lat:-8.50231418046777, lng: 116.09404476525197},
      {lat:-8.50231418046777, lng: 116.10915096642384},
      {lat:-8.488731955940734, lng: 116.13593014122853},
      {lat:-8.487373707044851, lng: 116.16064937950978},
      {lat:-8.48465719483924, lng: 116.2004748189629},
      {lat:-8.47514925085247, lng: 116.22931393029103},
      {lat:-8.473790953941506, lng: 116.27795811102726},
      {lat:-8.457491017026067, lng: 116.33151646063664},
      {lat:-8.44798240197778, lng: 116.35211582587101},
      {lat:-8.454774293800437, lng: 116.35417576239445},
      {lat:-8.473111803686951, lng: 116.3459360163007},
      {lat:-8.507712097952718, lng: 116.31162135352156},
      {lat:-8.521293649676679, lng: 116.313681290045},
      {lat:-8.549771255273749, lng: 116.29930428937655},
      {lat:-8.578967775417704, lng: 116.2855713792203},
      {lat:-8.593904662514964, lng: 116.27115182355624},
      {lat:-8.5918678489038, lng: 116.25192574933749},
      {lat:-8.597299327548845, lng: 116.23407296613436},
      {lat:-8.608840961144814, lng: 116.22583322004061},
      {lat:-8.613593296231107, lng: 116.21347360089999},
      {lat:-8.642784900626244, lng: 116.20660714582186},
      {lat:-8.69912508666848, lng: 116.21347360089999},
      {lat:-8.704263212793743, lng: 116.20454720929843},
      {lat:-8.717837709612501, lng: 116.1866944260953},
      {lat:-8.733447771271223, lng: 116.17433480695468},
      {lat:-8.763308676612313, lng: 116.15579537824374},
      {lat:-8.817595080490696, lng: 116.14137582257968},
      {lat:-8.847449205222695, lng: 116.13931588605624},
      {lat:-8.858304650716395, lng: 116.13931588605624},
      {lat:-8.866446024510157, lng: 116.13794259504061},
      {lat:-8.870516643745297, lng: 116.13244943097811},
      {lat:-8.870516643745297, lng: 116.11871652082186},
      {lat:-8.869159775680867, lng: 116.09605721906405},
      {lat:-8.875944065846031, lng: 116.07477120832186},
      {lat:-8.885441861303782, lng: 116.06653146222811},
      {lat:-8.88272823056316, lng: 116.05005197004061},
      {lat:-8.87526564247314, lng: 116.05142526105624},
      {lat:-8.863732253288543, lng: 116.07820443586093},
      {lat:-8.85559081937773, lng: 116.07545785382968},
      {lat:-8.84812767994937, lng: 116.0493653245328},
      {lat:-8.848806153425361, lng: 116.03563241437655},
      {lat:-8.853555432730591, lng: 116.02945260480624},
      {lat:-8.85966155887369, lng: 116.01777963117343},
      {lat:-8.86441069797339, lng: 116.00816659406405},
      {lat:-8.873230364828535, lng: 116.00679330304843},
      {lat:-8.880692994325585, lng: 116.00816659406405},
      {lat:-8.895136765508049, lng: 116.01689322835728},
      {lat:-8.89717192150505, lng: 116.00659354574009},
      {lat:-8.890388024187356, lng: 115.99698050863071},
      {lat:-8.88021194265435, lng: 115.98874076253696},
      {lat:-8.871392443559523, lng: 115.97844107991978},
      {lat:-8.861215835152992, lng: 115.96745475179478},
      {lat:-8.847646585635522, lng: 115.95372184163853},
      {lat:-8.838826305147084, lng: 115.94616874105259},
      {lat:-8.830005813509699, lng: 115.93380912191196},
      {lat:-8.836112330199963, lng: 115.91595633870884},
      {lat:-8.836112330199963, lng: 115.90908988363071},
      {lat:-8.830005813509699, lng: 115.90565665609165},
      {lat:-8.821185110927356, lng: 115.88368399984165},
      {lat:-8.819828061050918, lng: 115.87475760824009},
      {lat:-8.816644043995645, lng: 115.85188718242466},
      {lat:-8.8125728293561, lng: 115.8539471189481},
      {lat:-8.807144473408215, lng: 115.84639401836216},
      {lat:-8.801716037776101, lng: 115.83815427226841},
      {lat:-8.793573235024054, lng: 115.83472104472935},
      {lat:-8.77932289953294, lng: 115.8319744626981},
      {lat:-8.762357500772987, lng: 115.82373471660435},
      {lat:-8.754213834235532, lng: 115.82579465312779},
      {lat:-8.746069989452248, lng: 115.83403439922154},
      {lat:-8.735211252747547, lng: 115.8429607908231},
      {lat:-8.729103074365026, lng: 115.85051389140904},
      {lat:-8.756249767586713, lng: 115.86973996562779},
      {lat:-8.758285689795024, lng: 115.87523312969029},
      {lat:-8.766429267149332, lng: 115.88209958476841},
      {lat:-8.780680097939028, lng: 115.91299863261997},
      {lat:-8.771179604856803, lng: 115.93565793437779},
      {lat:-8.765750642518128, lng: 115.94801755351841},
      {lat:-8.750820587228432, lng: 115.96037717265904},
      {lat:-8.746748649988263, lng: 115.99788268552743},
      {lat:-8.760437922575557, lng: 116.02466186033212},
      {lat:-8.7706173074351, lng: 116.03976806150399},
      {lat:-8.773331762954795, lng: 116.04800780759774},
      {lat:-8.773331762954795, lng: 116.07135375486337},
      {lat:-8.762473821853584, lng: 116.07135375486337},
      {lat:-8.745507654064173, lng: 116.07616027341805},
      {lat:-8.735327582309843, lng: 116.08302672849618},
      {lat:-8.728540713383703, lng: 116.08371337400399},
      {lat:-8.714966605333966, lng: 116.06998046384774},
      {lat:-8.710215551012757, lng: 116.06448729978524},
      {lat:-8.694604519160787, lng: 116.07135375486337},
      {lat:-8.673562534176153, lng: 116.07410033689462},
      {lat:-8.650482872589624, lng: 116.07135375486337},
      {lat:-8.643015620234623, lng: 116.0734136913868},
      {lat:-8.634190494920695, lng: 116.07547362791024},
      {lat:-8.626722919964742, lng: 116.07753356443368},
      {lat:-8.624686282980695, lng: 116.08508666501962},
      {lat:-8.625365163195562, lng: 116.09469970212899},
      {lat:-8.626044042190278, lng: 116.10431273923837},
      {lat:-8.622649635016051, lng: 116.11804564939462},
      {lat:-8.623328518890833, lng: 116.1338384960743},
      {lat:-8.619255197347188, lng: 116.14688476072274},
      {lat:-8.620612976073328, lng: 116.1777838085743},
      {lat:-8.615181831908021, lng: 116.18533690916024},
      {lat:-8.604319309623007, lng: 116.18396361814462},
      {lat:-8.587345994844654, lng: 116.1777838085743},
      {lat:-8.574083444466043, lng: 116.1738394461986},
      {lat:-8.557108778056437, lng: 116.1683462821361},
      {lat:-8.553713753918506, lng: 116.13154159597934},
      {lat:-8.555750772033, lng: 116.10956893972934},
      {lat:-8.551676724911095, lng: 116.08210311941684},
      {lat:-8.546244594322784, lng: 116.07523666433872},
      {lat:-8.52519435770277, lng: 116.06562362722934},
      {lat:-8.517724640077672, lng: 116.06150375418247},
      {lat:-8.509575690875092, lng: 116.05463729910434},
      {lat:-8.502105668429147, lng: 116.04777084402622},
      {lat:-8.498031049358183, lng: 116.04639755301059},
    ];

    return (
      <Page
      title="Analisa"
      breadcrumbs={[{ name: 'Analisa', active: true }]}
      className="Analisa">
{
  <div>
<Map 
        onClick={this.onMapClicked}
        google={this.props.google}
  initialCenter={{
    lat: -8.646360,
    lng: 116.327261
   }}
   zoom={10}
    style={{width: '100%', height: '600px', position: 'absolute'}}
    styles={[
      {elementType: 'geometry', stylers: [{color: '#ebe3cd'}]},
      {elementType: 'labels.text.fill', stylers: [{color: '#523735'}]},
      {elementType: 'labels.text.stroke', stylers: [{color: '#f5f1e6'}]},
      {
        featureType: 'administrative',
        elementType: 'geometry.stroke',
        stylers: [{color: '#c9b2a6'}]
      },
      {
        featureType: 'administrative.land_parcel',
        elementType: 'geometry.stroke',
        stylers: [{color: '#dcd2be'}]
      },
      {
        featureType: 'administrative.land_parcel',
        elementType: 'labels.text.fill',
        stylers: [{color: '#ae9e90'}]
      },
      {
        featureType: 'landscape.natural',
        elementType: 'geometry',
        stylers: [{color: '#dfd2ae'}]
      },
      {
        featureType: 'poi',
        elementType: 'geometry',
        stylers: [{color: '#dfd2ae'}]
      },
      {
        featureType: 'poi',
        elementType: 'labels.text.fill',
        stylers: [{color: '#93817c'}]
      },
      {
        featureType: 'poi.park',
        elementType: 'geometry.fill',
        stylers: [{color: '#a5b076'}]
      },
      {
        featureType: 'poi.park',
        elementType: 'labels.text.fill',
        stylers: [{color: '#447530'}]
      },
      {
        featureType: 'road',
        elementType: 'geometry',
        stylers: [{color: '#f5f1e6'}]
      },
      {
        featureType: 'road.arterial',
        elementType: 'geometry',
        stylers: [{color: '#fdfcf8'}]
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry',
        stylers: [{color: '#f8c967'}]
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry.stroke',
        stylers: [{color: '#e9bc62'}]
      },
      {
        featureType: 'road.highway.controlled_access',
        elementType: 'geometry',
        stylers: [{color: '#e98d58'}]
      },
      {
        featureType: 'road.highway.controlled_access',
        elementType: 'geometry.stroke',
        stylers: [{color: '#db8555'}]
      },
      {
        featureType: 'road.local',
        elementType: 'labels.text.fill',
        stylers: [{color: '#806b63'}]
      },
      {
        featureType: 'transit.line',
        elementType: 'geometry',
        stylers: [{color: '#dfd2ae'}]
      },
      {
        featureType: 'transit.line',
        elementType: 'labels.text.fill',
        stylers: [{color: '#8f7d77'}]
      },
      {
        featureType: 'transit.line',
        elementType: 'labels.text.stroke',
        stylers: [{color: '#ebe3cd'}]
      },
      {
        featureType: 'transit.station',
        elementType: 'geometry',
        stylers: [{color: '#dfd2ae'}]
      },
      {
        featureType: 'water',
        elementType: 'geometry.fill',
        stylers: [{color: '#b9d3c2'}]
      },
      {
        featureType: 'water',
        elementType: 'labels.text.fill',
        stylers: [{color: '#92998d'}]
      }
  ]}
    className={'map'}>

{ this.state.data.map(data =>

  <Marker
  onClick={this.onMarkerClick}
    title={'Lokasi Rumah Korban'}
    name={data.nama}
    img={data.fpondasi}
    img2={data.fkolom}
    kewenangan={data.kewenangan}
    status={data.status}
    tingkat={data.tingkat}
    kerugian={data.harga}
    luas={data.luas}
    sektor={data.sektor}
    position={{lat: data.lot, lng: data.long}} />
 )}

     <InfoWindow
     onOpen={this.windowHasOpened}
     onClose={this.windowHasClosed}
          marker={this.state.activeMarker}
          visible={this.state.showingInfoWindow}>
            <div>
            <Card className="flex-row">
            <CardImg
              className="card-img-left"
              src={this.state.selectedPlace.img}
              style={{ width: 200, height: 300 }}
            />
            <CardImg
              className="card-img-left"
              src={this.state.selectedPlace.img2}
              style={{ width: 200, height: 300 }}
            />
            <CardBody>
              <CardTitle>{this.state.selectedPlace.name}</CardTitle>
              <ListGroup flush>
              <ListGroupItem>{'Luas : (M2) '+this.state.selectedPlace.luas}</ListGroupItem>
              <ListGroupItem>{'Kerugian : Rp.'+this.state.selectedPlace.kerugian}</ListGroupItem>
              <ListGroupItem>{'Sektor : '+this.state.selectedPlace.sektor}</ListGroupItem>
              <ListGroupItem>{'Kewenangan : '+this.state.selectedPlace.kewenangan}</ListGroupItem>
              <ListGroupItem>{'Tingkat : '+this.state.selectedPlace.tingkat}</ListGroupItem>
              <ListGroupItem>{'Status : '+this.state.selectedPlace.status}</ListGroupItem>
            </ListGroup>
            </CardBody>
          </Card>
            </div>
        </InfoWindow>

        {/* <Polyline
        onClick={this.onMarkerClick}
          path={triangleCoords}
          strokeColor="#0000FF"
          strokeOpacity={0.8}
          strokeWeight={2} /> */}

        <Polygon
        name="Lombok Utara"
        total={this.state.totalkab[0]}
        kerugian={this.state.kerugiankab[0]}
        ringan={this.state.kringan[1]}
        sedang={this.state.ksedang[1]}
        berat={this.state.kberat[1]}
        pending={this.state.pending[1]}
        diterima={this.state.diterima[1]}
        onClick={this.onOpenModal}
          paths={lotur}
          strokeColor="#809fff"
          strokeOpacity={0.5}
          strokeWeight={1}
          fillColor="#ffad33"
          fillOpacity={0.25} />

<Polygon
name="Lombok Barat"
total={this.state.totalkab[4]}
ringan={this.state.kringan[4]}
        sedang={this.state.ksedang[4]}
        berat={this.state.kberat[4]}
kerugian={this.state.kerugiankab[4]}
pending={this.state.pending[4]}
diterima={this.state.diterima[4]}
        onClick={this.onOpenModal}
          paths={lobar}
          strokeColor="#809fff"
          strokeOpacity={0.5}
          strokeWeight={1}
          fillColor="#809fff"
          fillOpacity={0.25} />

<Polygon
name="Lombok Timur"
ringan={this.state.kringan[2]}
        sedang={this.state.ksedang[2]}
        berat={this.state.kberat[2]}
total={this.state.totalkab[2]}
kerugian={this.state.kerugiankab[2]}
pending={this.state.pending[2]}
diterima={this.state.diterima[2]}
        onClick={this.onOpenModal}
          paths={lotim}
          strokeColor="#809fff"
          strokeOpacity={0.5}
          strokeWeight={1}
          fillColor="#ff99cc"
          fillOpacity={0.25} />

<Polygon
name="Lombok Tengah"
total={this.state.totalkab[3]}
ringan={this.state.kringan[3]}
        sedang={this.state.ksedang[3]}
        berat={this.state.kberat[3]}
kerugian={this.state.kerugiankab[3]}
pending={this.state.pending[3]}
diterima={this.state.diterima[3]}
        onClick={this.onOpenModal}
          paths={loteng}
          strokeColor="#809fff"
          strokeOpacity={0.5}
          strokeWeight={1}
          fillColor="#ffff66"
          fillOpacity={0.25} />

<Polygon
name="Kota Mataram"
ringan={this.state.kringan[0]}
        sedang={this.state.ksedang[0]}
        berat={this.state.kberat[0]}
total={this.state.totalkab[2]}
kerugian={this.state.kerugiankab[2]}
pending={this.state.pending[2]}
diterima={this.state.diterima[2]}
        onClick={this.onOpenModal}
          paths={mataram}
          strokeColor="#809fff"
          strokeOpacity={0.5}
          strokeWeight={1}
          fillColor="#99ff99"
          fillOpacity={0.25} />

</Map>

<Modal open={open} onClose={this.onCloseModal} center showCloseIcon styles={styles}>
          {/* <h2>{this.state.selectedPoly.name}</h2> */}
          <Card className="flex-row">
            <CardBody>
              <CardTitle>{this.state.selectedPoly.name}</CardTitle>
              <ListGroup flush>
              <ListGroupItem>{'Total Kerusakan : '+this.state.selectedPoly.total}</ListGroupItem>
              <ListGroupItem>{'Total Kerugian : Rp.'+this.state.selectedPoly.kerugian}</ListGroupItem>
              <ListGroupItem>{'Kerusakan Ringan : '+this.state.selectedPoly.ringan}</ListGroupItem>
              <ListGroupItem>{'Kerusakan Sedang : '+this.state.selectedPoly.sedang}</ListGroupItem>
              <ListGroupItem>{'Kerusakan Berat : '+this.state.selectedPoly.berat}</ListGroupItem>
              <ListGroupItem>{'Bantuan Diterima : '+this.state.selectedPoly.diterima}</ListGroupItem>
              <ListGroupItem>{'Bantuan Dipending : '+this.state.selectedPoly.pending}</ListGroupItem>
            </ListGroup>
            </CardBody>
          </Card>

        </Modal>

</div>



    }
    </Page>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: 'AIzaSyC_st_Q_hTI2NwDNa5RV1E70uYs3uf_aDs'
})(Analisa);
